import Button from '@atlaskit/button';
import { Code } from '@atlaskit/code';
import Form, { Field } from '@atlaskit/form';
import Page, { Grid, GridColumn } from '@atlaskit/page';
import { FlexContainer } from '@atlaskit/right-side-panel';
import TextField from '@atlaskit/textfield';
import React from 'react';
import styled from 'styled-components';

const PageWrapper = styled.div`
    padding: 0 24px;
    width: 100%;
`;

const ArrowLabel = styled.div`
    padding-top: 10px;
    padding-bottom: 20px;
`;

const CodeLabel = styled.label`
    font-size: 0.857em;
    line-height: 1.333;
    color: #6b778c;
    font-weight: 600;
    margin-top: 16px;
    display: inline-block;
    margin-bottom: 4px;
    margin-top: 16px;
`;

const styles = {
    purpleBtn: {
        color: 'white !important',
        backgroundColor: '#8777d9',
    },
};

function InstallationDetails({ widgetKey }) {
    return (
        <Page>
            <Grid layout="fluid">
                <GridColumn medium={12}>
                    <FlexContainer id="attach">
                        <PageWrapper>
                            <ArrowLabel>Back to notifications list</ArrowLabel>
                            <div style={{ width: '40%', margin: 'auto' }}>
                                <h1>Widget installation</h1>
                                <p>
                                    Copy and paste following code to embed Pijen notification widget in your app. You
                                    can stylize the notification button that is going to trigger widget to open.
                                </p>

                                <Form>
                                    {({ formProps }) => (
                                        <form {...formProps}>
                                            <Field name="widget-key" defaultValue={widgetKey} label="Widget key">
                                                {({ fieldProps }) => (
                                                    <>
                                                        <TextField {...fieldProps} isReadOnly />
                                                    </>
                                                )}
                                            </Field>
                                        </form>
                                    )}
                                </Form>

                                <CodeLabel htmlFor="toggle"> Embed widget</CodeLabel>
                                <div
                                    style={{
                                        border: '2px solid #DFE1E6',
                                        padding: '8px 6px',
                                        borderRadius: '3px',
                                    }}
                                >
                                    <Code>{`<Pijen authKey="${widgetKey}" apiDomain="https://pijen.jexo.cloud" userKey="JIRA-USER-ACCOUNT-ID" headingText="What's new in our app?">\n  {({ openPijen, notificationCounter }) => (\n    <button onClick={openPijen}>\n      Pijen ({notificationCounter})\n    </button>\n  )}\n</Pijen>`}</Code>
                                </div>
                                <div style={{ textAlign: 'center', paddingTop: '20px' }}>
                                    <Button css={styles.purpleBtn} href="https://jexo.app/pijen" target="_blank">
                                        Read more information
                                    </Button>
                                </div>
                            </div>
                        </PageWrapper>
                    </FlexContainer>
                </GridColumn>
            </Grid>
        </Page>
    );
}

export default InstallationDetails;
